module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "DashboardView__container"
  }, [_c('ThePage', {
    attrs: {
      "class-name": 'DashboardView'
    }
  }, [_c('template', {
    slot: "left-action"
  }, [_c('TheLogo')], 1), _vm._v(" "), _c('template', {
    slot: "right-action"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "label": 'DASHBOARD__CONFIGURATION',
      "icon": 'icon-cog'
    },
    on: {
      "click": _vm.openConfiguration
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "DashboardView__body"
  }, [_c('DashboardItem', {
    attrs: {
      "name": 'DASHBOARD__LIST',
      "icon": 'icon-th-list'
    },
    on: {
      "click": _vm.openList
    }
  }), _vm._v(" "), _c('DashboardItem', {
    attrs: {
      "name": 'DASHBOARD__FORM',
      "icon": 'icon-ok-squared'
    },
    on: {
      "click": _vm.openForm
    }
  }), _vm._v(" "), _c('DashboardItem', {
    attrs: {
      "name": 'DASHBOARD__TABLE',
      "icon": 'icon-table'
    },
    on: {
      "click": _vm.openTable
    }
  }), _vm._v(" "), _c('DashboardItem', {
    attrs: {
      "name": 'DASHBOARD__CATALOG',
      "icon": 'icon-th'
    },
    on: {
      "click": _vm.openCatalog
    }
  })], 1)], 2), _vm._v(" "), (_vm.formVisible) ? _c('FormModal') : _vm._e(), _vm._v(" "), (_vm.configurationVisible) ? _c('ConfigurationModal') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb338a0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DashboardView.vue
// module id = 560
// module chunks = 1